module.exports = __webpack_public_path__ + "static/media/logo109.b5009103.png";